import { EditOutlined } from '@ant-design/icons';
import { Space, Tag } from 'antd';
import UIIconTooltip from 'common/ui/UIIconTooltip';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { linkCell } from 'utils/cell-formatter';
import { activeColors, activeLabels } from 'utils/constants';
import { cloudflareCdn } from 'utils/image';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) => linkCell({ getValue, path: '/admin/banks' }),
  },
  {
    accessorKey: 'logo',
    header: 'Logo',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        value && <img width={80} src={cloudflareCdn(value, 80)} alt="Logo" />
      );
    },
  },
  {
    accessorKey: 'code',
    header: 'Code',
  },
  {
    accessorKey: 'fmarket_id',
    header: 'Fmarket ID',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        value && (
          <Space>
            <Check color="green" size={18} className="mt-1.5" />
            {value}
          </Space>
        )
      );
    },
  },
  {
    accessorKey: 'nhsv_code',
    header: 'NHSV Code',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        value && (
          <Space>
            <Check color="green" size={18} className="mt-1.5" />
            {value}
          </Space>
        )
      );
    },
  },
  {
    accessorKey: 'vcam_id',
    header: 'VCAM ID',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        value && (
          <Space>
            <Check color="green" size={18} className="mt-1.5" />
            {value}
          </Space>
        )
      );
    },
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'trading_name',
    header: 'Trading Name',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => {
      const value = getValue();
      const status = value === 1001 ? 'active' : 'inactive';
      return <Tag color={activeColors[status]}>{activeLabels[status]}</Tag>;
    },
  },
  {
    accessorKey: 'id',
    header: 'Action',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => (
      <Link to={`/admin/banks/${getValue()}/edit`}>
        <UIIconTooltip title="Edit" Icon={EditOutlined} />
      </Link>
    ),
  },
];
